<template>
  <div class="home">
    <div class="head-box">
      <headPage/>
    </div>
    <div class="bx-content main">
      <div class="nav-tex">
        <div class="name">您现在的位置：{{name}}</div>
        <div class="name">欢迎 <b>{{user.mnickname}}</b> ，使用社会组织专家智库系统！</div>
      </div>
      <div class="contents">
        <leftPage :active="active" :act="act"/>
        <div class="right-box">
          <router-view @setActive="getActive"></router-view>
        </div>
      </div>
    </div>
    <div class="foot-box">
      <footPage />
    </div>
    <router-link to="/version">
      <img class="version" src="@/assets/img/icon_version.png"/>
    </router-link>
    <version-index-detail-dialog :detailDialogVisible="detailDialogVisible" :nid="cur_nid"
                                 @watchState="watchState"></version-index-detail-dialog>
    <help-windows></help-windows>
  </div>
</template>
<script>
import headPage from './common/headPage'
import leftPage from './common/leftPage'
import footPage from './common/footPage'
import HelpWindows from "@/components/HelpWindows";
import VersionIndexDetailDialog from "@/components/VersionIndexDetailDialog";
import {getInfo} from "@/api/login";
export default {
  name: "home",
  data() {
    return {
      active: 0,
      name: '',
      act: 0,
      detailDialogVisible: false,
      cur_nid: 0,
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  components: {
    VersionIndexDetailDialog,
    HelpWindows,
    headPage,
    leftPage,
    footPage
  },
  created() {
    this.getUpInfo()
  },
  methods: {
    async getUpInfo() {
      let _data = await getInfo(this.user.type, this.user.mid)
      if (_data.data.id) {
        this.cur_nid = _data.data.id
        this.detailDialogVisible = true
      }
    },

    watchState() {
      this.detailDialogVisible = false;
    },

    getActive(data){
      this.active = Number(data.active)
      this.name = data.name
      this.act = Number(data.act)
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.home {
  .head-box {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .main {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 230px);

    .nav-tex {
      width: 100%;
      padding: 15px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .name {
        font-size: 16px;
        color: #666666;
      }
    }

    .contents {
      display: flex;
      justify-content: space-between;

      .right-box {
        //display: flex;
        //flex-direction: column;
        width: calc(100% - 180px);
        min-height: calc(100vh - 220px);
        background-color: #0a2240;
        border-radius: 10px;
        padding: 10px;
        margin-left: 10px;
        //flex: 1;
      }
    }

  }

.foot-box {
  padding-top: 25px;
  width: 100%;
}
}
</style>


